import { observer } from "mobx-react-lite";
import { Container, Grid, Header, Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { useStore } from "../../../app/stores/store";
import PageHeader from "../../../app/layout/PageHeader";
import { ARReportFilter, ReportType } from "../../../app/models/enums";
import AccountsReceivablePrintDetailedTable from "./AccountsReceivable/AccountsReceivablePrintDetailedTable";
import AccountsReceivablePrintSummaryTable from "./AccountsReceivable/AccountsReceivablePrintSummaryTable";

interface Props {
  startDate: Date;
  endDate: Date;
  reportType: ReportType | undefined;
  typeOfBalance: ARReportFilter | undefined;
}

export default observer(function AccountsReceivablePrint({
  startDate,
  endDate,
  reportType,
  typeOfBalance
}: Props) {
  const { t } = useTranslation(["common", "reports"]);

  const { accountsReceivableReportStore } = useStore();
  const {
    groupedAccountsReceivableReport,
    getAccountsReceivableReport,
    calculateTotals,
    calculateTotalBalanceDue
  } = accountsReceivableReportStore;

  return (
    <>
      <Container className="page">
        <Grid stackable columns={2} className="headerPrint">
          <Grid.Row>
            <Grid.Column>
              <PageHeader
                header={`${t("report", { ns: "reports" })}: ${t(
                  "accountsReceivable",
                  {
                    ns: "accountsReceivable",
                  }
                )}`}
                type="h2"
                divider={false}
                getAlerts={true}
                addTitle={true}
              />
            </Grid.Column>
            <Grid.Column>
              <Header
                content={`${format(startDate, "PP")} - ${format(
                  endDate,
                  "PP"
                )} - ${reportType === ReportType.Detailed ? "Detailed" : "Summary"}
                  ${typeOfBalance === ARReportFilter.Open ? "- Open Balances" : typeOfBalance === ARReportFilter.Closed ? "- Closed Balances" : ""}`}
                as="h3"
                textAlign="right"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {getAccountsReceivableReport && getAccountsReceivableReport.length > 0 && (
          <Table striped unstackable className="dnxTable">
              {
                reportType === ReportType.Detailed
                  ? <AccountsReceivablePrintDetailedTable
                    calculateTotals={calculateTotals}
                    calculateTotalBalanceDue={calculateTotalBalanceDue}
                    allValues={getAccountsReceivableReport}
                    groupedValues={groupedAccountsReceivableReport}
                  />
                  : <AccountsReceivablePrintSummaryTable
                    allValues={getAccountsReceivableReport}
                  />
              }
          </Table>
        )}
 
      </Container>
    </>
  );
});
